import { memo } from 'react';
import StatusBadge from '@atoms/Widgets/StatusBadge';
import { IDataGridCellDeps, withLink } from '../cellLink';
import { DataGridRow, rowValue } from '../dataGridSchema';

export interface IStatusCellProps {
    row: DataGridRow;
    field: string;
    deps: IDataGridCellDeps;
}

/** Статус строки чипом. Мемоизирован по той же причине, что и ячейка значения. */
const StatusCell = memo(({ row, field, deps }: IStatusCellProps) => {
    const raw = rowValue(row, field);
    const value = raw == null ? '' : String(raw);
    return withLink(
        row,
        deps,
        <StatusBadge status={value} className="search-folder-status" testid="search-folder-document-status" />,
    );
});
StatusCell.displayName = 'StatusCell';

export default StatusCell;
